import useFormatter from "@coworker/app/src/hooks/useFormatter";
import styles from "../notification.module.css";
import { NotificationStringItem } from "./NotificationStringItem";
import { NotificationString } from "./types/translated-strings.types";

interface NotificationFooterProps {
  createdAt: string;
  footer: NotificationString;
}

export const NotificationFooter = ({
  createdAt,
  footer,
}: NotificationFooterProps) => {
  const { formatDateTimeShort } = useFormatter();

  return (
    <div className={styles["notification-item-footer"] ?? ""}>
      {!!footer.text && (
        <>
          <NotificationStringItem notificationString={footer} />
          <span className={styles["notification-item-footer-bullet"] ?? ""}>
            &bull;
          </span>
        </>
      )}
      <span>{`${formatDateTimeShort(createdAt)}`}</span>
    </div>
  );
};
